
























import { Component, Vue, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { projectManage } from '../project';


type IUpdateProjectInfo = IProject.IRequest.IUpdateProjectInfo;

interface IForm {
  name: string;
  description: string;
  active: boolean;
}

@Component
export default class ProjectForm extends Vue {
  @Ref() private readonly editProjectForm!: FormModel;
  private rules = {
    name: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
  };
  private loading = false;
  private form: IForm = {
    name: '',
    description: '',
    active: true,
  };
  private created() {
    this.readyFormData();
  }
  private readyFormData() {
    if (!projectManage.editData.projectInfo) {
      return;
    }
    const { name, description, active } = projectManage.editData.projectInfo!;
    this.form = {
      name,
      description,
      active,
    };
  }
  private handleSubmit() {
    this.editProjectForm.validate((valid) => {
      if (valid) {
        const {name, description, active} = this.form;
        const params: IUpdateProjectInfo = {
          name,
          description,
          active,
        };
        this.submitUpdateProject(params);
      } else {
        return false;
      }
    });
  }
  private submitUpdateProject(params: IUpdateProjectInfo) {
    this.loading = true;
    projectManage.requestUpdateProject(params).then((res) => {
      this.loading = false;
      this.$message.success(res);
      this.endEdit();
    }).catch((err) => {
      this.$message.warning(err);
      this.loading = false;
    });
  }
  private endEdit() {
    this.$emit('ok');
  }
}
